// D-Rex Double Walled Corrugated Underground Drainage System
// HSN CODE: 39172190 (pipes), 34031900 (accessories)

export const drexCatalog = {
    title: "ASTRAL D-REX - DOUBLE WALLED CORRUGATED UNDERGROUND DRAINAGE SYSTEM",
    hsn_pipes: "39172190",
    hsn_accessories: "34031900",
    certification: "IS:16098 (Part-2)",

    // SN4 Plain Pipe 3m
    sn4_plain_3m: [
        { size: "7.5/75", len: 3, code: "A214075C0003C", price: 149 },
        { size: "10.0/100", len: 3, code: "A214100C0003C", price: 182 },
        { size: "13.5/135", len: 3, code: "A214135C0003C", price: 309 },
        { size: "15.0/150", len: 3, code: "A214150C0003C", price: 353 },
        { size: "17.0/170", len: 3, code: "A214170C0003C", price: 484 },
        { size: "20.0/200", len: 3, code: "A214200C0003C", price: 560 },
        { size: "25.0/250", len: 3, code: "A214250C0003C", price: 1058 },
        { size: "30.0/300", len: 3, code: "A214300C0003C", price: 1359 },
        { size: "40.0/400", len: 3, code: "A214400C0003C", price: 2772 },
        { size: "50.0/500", len: 3, code: "A214500C0003C", price: 4079 },
        { size: "60.0/600", len: 3, code: "A214600C0003C", price: 6623 },
        { size: "80.0/800", len: 3, code: "A214800C0003C", price: 11238 }
    ],

    // SN4 Plain Pipe 6m
    sn4_plain_6m: [
        { size: "7.5/75", len: 6, code: "A214075C0006C", price: 142 },
        { size: "10.0/100", len: 6, code: "A214100C0006C", price: 179 },
        { size: "13.5/135", len: 6, code: "A214135C0006C", price: 293 },
        { size: "15.0/150", len: 6, code: "A214150C0006C", price: 346 },
        { size: "17.0/170", len: 6, code: "A214170C0006C", price: 465 },
        { size: "20.0/200", len: 6, code: "A214200C0006C", price: 539 },
        { size: "25.0/250", len: 6, code: "A214250C0006C", price: 936 },
        { size: "30.0/300", len: 6, code: "A214300C0006C", price: 1294 },
        { size: "40.0/400", len: 6, code: "A214400C0006C", price: 2461 },
        { size: "50.0/500", len: 6, code: "A214500C0006C", price: 3564 },
        { size: "60.0/600", len: 6, code: "A214600C0006C", price: 5621 },
        { size: "80.0/800", len: 6, code: "A214800C0006C", price: 9285 }
    ],

    // SN4 In-line Socketed 6m
    sn4_socketed_6m: [
        { size: "10.0/100", len: 6, code: "A214100S0006C", price: 179 },
        { size: "15.0/150", len: 6, code: "A214150S0006C", price: 346 },
        { size: "17.0/170", len: 6, code: "A214170S0006C", price: 465 },
        { size: "20.0/200", len: 6, code: "A214200S0006C", price: 539 },
        { size: "25.0/250", len: 6, code: "A214250S0006C", price: 936 },
        { size: "30.0/300", len: 6, code: "A214300S0006C", price: 1196 },
        { size: "40.0/400", len: 6, code: "A214400S0006C", price: 2358 },
        { size: "50.0/500", len: 6, code: "A214500S0006C", price: 3398 },
        { size: "60.0/600", len: 6, code: "A214600S0006C", price: 5103 },
        { size: "80.0/800", len: 6, code: "A214800S0006C", price: 8164 }
    ],

    // SN8 Plain Pipe 3m
    sn8_plain_3m: [
        { size: "7.5/75", len: 3, code: "A215075C0003B", price: 158 },
        { size: "10.0/100", len: 3, code: "A215100C0003B", price: 201 },
        { size: "13.5/135", len: 3, code: "A215135C0003B", price: 347 },
        { size: "15.0/150", len: 3, code: "A215150C0003B", price: 382 },
        { size: "17.0/170", len: 3, code: "A215170C0003B", price: 519 },
        { size: "20.0/200", len: 3, code: "A215200C0003B", price: 679 },
        { size: "25.0/250", len: 3, code: "A215250C0003B", price: 1085 },
        { size: "30.0/300", len: 3, code: "A215300C0003B", price: 1904 },
        { size: "40.0/400", len: 3, code: "A215400C0003B", price: 3401 },
        { size: "50.0/500", len: 3, code: "A215500C0003B", price: 5408 },
        { size: "60.0/600", len: 3, code: "A215600C0003B", price: 9040 },
        { size: "80.0/800", len: 3, code: "A215800C0003B", price: 17760 }
    ],

    // SN8 Plain Pipe 6m  
    sn8_plain_6m: [
        { size: "7.5/75", len: 6, code: "A215075C0006B", price: 149 },
        { size: "10.0/100", len: 6, code: "A215100C0006B", price: 189 },
        { size: "13.5/135", len: 6, code: "A215135C0006B", price: 327 },
        { size: "15.0/150", len: 6, code: "A215150C0006B", price: 360 },
        { size: "17.0/170", len: 6, code: "A215170C0006B", price: 489 },
        { size: "20.0/200", len: 6, code: "A215200C0006B", price: 634 },
        { size: "25.0/250", len: 6, code: "A215250C0006B", price: 1004 },
        { size: "30.0/300", len: 6, code: "A215300C0006B", price: 1538 },
        { size: "40.0/400", len: 6, code: "A215400C0006B", price: 2616 },
        { size: "50.0/500", len: 6, code: "A215500C0006B", price: 4160 },
        { size: "60.0/600", len: 6, code: "A215600C0006B", price: 6696 },
        { size: "80.0/800", len: 6, code: "A215800C0006B", price: 11840 }
    ],

    // SN8 In-line Socketed 6m
    sn8_socketed_6m: [
        { size: "10.0/100", len: 6, code: "A215100S0006B", price: 189 },
        { size: "15.0/150", len: 6, code: "A215150S0006B", price: 360 },
        { size: "17.0/170", len: 6, code: "A215170S0006B", price: 489 },
        { size: "20.0/200", len: 6, code: "A215200S0006B", price: 634 },
        { size: "25.0/250", len: 6, code: "A215250S0006B", price: 1004 },
        { size: "30.0/300", len: 6, code: "A215300S0006B", price: 1423 },
        { size: "40.0/400", len: 6, code: "A215400S0006B", price: 2507 },
        { size: "50.0/500", len: 6, code: "A215500S0006B", price: 3966 },
        { size: "60.0/600", len: 6, code: "A215600S0006B", price: 6284 },
        { size: "80.0/800", len: 6, code: "A215800S0006B", price: 10933 }
    ],

    // Rodent Repellent SN8 Plain 3m
    rodent_sn8_plain_3m: [
        { size: "7.5/75", len: 3, code: "A219075C0003B", price: 166 },
        { size: "10.0/100", len: 3, code: "A219100C0003B", price: 211 },
        { size: "13.5/135", len: 3, code: "A219135C0003B", price: 364 },
        { size: "15.0/150", len: 3, code: "A219150C0003B", price: 401 },
        { size: "17.0/170", len: 3, code: "A219170C0003B", price: 545 },
        { size: "20.0/200", len: 3, code: "A219200C0003B", price: 713 },
        { size: "25.0/250", len: 3, code: "A219250C0003B", price: 1139 },
        { size: "30.0/300", len: 3, code: "A219300C0003B", price: 1999 },
        { size: "40.0/400", len: 3, code: "A219400C0003B", price: 3571 },
        { size: "50.0/500", len: 3, code: "A219500C0003B", price: 5678 },
        { size: "60.0/600", len: 3, code: "A219600C0003B", price: 9492 },
        { size: "80.0/800", len: 3, code: "A219800C0003B", price: 18648 }
    ],

    // Rodent Repellent SN8 Socketed 6m
    rodent_sn8_socketed_6m: [
        { size: "10.0/100", len: 6, code: "A219100S0006B", price: 198 },
        { size: "15.0/150", len: 6, code: "A219150S0006B", price: 378 },
        { size: "17.0/170", len: 6, code: "A219170S0006B", price: 513 },
        { size: "20.0/200", len: 6, code: "A219200S0006B", price: 666 },
        { size: "25.0/250", len: 6, code: "A219250S0006B", price: 1054 },
        { size: "30.0/300", len: 6, code: "A219300S0006B", price: 1494 },
        { size: "40.0/400", len: 6, code: "A219400S0006B", price: 2632 },
        { size: "50.0/500", len: 6, code: "A219500S0006B", price: 4164 },
        { size: "60.0/600", len: 6, code: "A219600S0006B", price: 6598 },
        { size: "80.0/800", len: 6, code: "A219800S0006B", price: 11480 }
    ],

    // Jack (HSN: 34031900)
    jack: [
        { size: "13.5/135", code: "TR99000135", price: 4554 },
        { size: "15.0/150", code: "TR99010150", price: 5357 },
        { size: "17.0/170", code: "TR99000170", price: 6862 },
        { size: "20.0/200", code: "TR99010200", price: 7624 },
        { size: "25.0/250", code: "TR99010250", price: 8205 },
        { size: "30.0/300", code: "TR99010300", price: 14615 },
        { size: "40.0/400", code: "TR99000400", price: 18578 },
        { size: "50.0/500", code: "TR99000500", price: 23378 },
        { size: "60.0/600", code: "TR99000600", price: 43665 },
        { size: "80.0/800", code: "TR99000800", price: 50162 }
    ],

    // Coupler with Two Rubber Rings (HSN: 34031900)
    coupler: [
        { size: "7.5/75", code: "A2075BLK00", price: 74 },
        { size: "10.0/100", code: "A2100BLK00", price: 131 },
        { size: "13.5/135", code: "A2135BLK00", price: 205 },
        { size: "15.0/150", code: "A2150BLK00", price: 228 },
        { size: "17.0/170", code: "A2170BLK00", price: 301 },
        { size: "20.0/200", code: "A2200BLK00", price: 394 },
        { size: "25.0/250", code: "A2250BLK00", price: 702 },
        { size: "30.0/300", code: "A2300BLK00", price: 2181 },
        { size: "40.0/400", code: "A2400BLK00", price: 4293 },
        { size: "50.0/500", code: "A2500BLK00", price: 5613 },
        { size: "60.0/600", code: "A2600BLK00", price: 12865 },
        { size: "80.0/800", code: "A2800BLK00", price: 19616 }
    ]
};

export const formatPrice = (p) => p ? `₹${p.toFixed(2)}` : 'N/A';

export const getAllDrexProducts = () => {
    const all = [];
    const types = {
        'sn4_plain_3m': 'SN4 Plain 3m', 'sn4_plain_6m': 'SN4 Plain 6m', 'sn4_socketed_6m': 'SN4 Socketed 6m',
        'sn8_plain_3m': 'SN8 Plain 3m', 'sn8_plain_6m': 'SN8 Plain 6m', 'sn8_socketed_6m': 'SN8 Socketed 6m',
        'rodent_sn8_plain_3m': 'Rodent SN8 Plain 3m', 'rodent_sn8_socketed_6m': 'Rodent SN8 Socketed 6m',
        'jack': 'Jack', 'coupler': 'Coupler'
    };
    Object.keys(types).forEach(k => {
        drexCatalog[k]?.forEach((item, i) => {
            all.push({ id: `${k}-${i}`, ...item, type: types[k], category: k });
        });
    });
    return all;
};

export const getDrexSizes = () => [...new Set(getAllDrexProducts().map(p => p.size))].sort((a, b) => parseFloat(a) - parseFloat(b));
export const getDrexTypes = () => [...new Set(getAllDrexProducts().map(p => p.type))];
